// extracted by css-extract-rspack-plugin
export default {"signInWithEmailLink":"SSO_signInWithEmailLink__V6YAO","gatewaySpinnerWrapper":"SSO_gatewaySpinnerWrapper__BUT7e"};